import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectShowKbSearchOnInboxEditor = createBasicSelector(state =>
  selectBooleanPreferenceByName(state, 'show_kb_search_on_inbox_editor')
)
